module.exports = __webpack_public_path__ + "static/media/download.fc71928c.svg";